import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { createFileRoute } from '@tanstack/react-router';
import { FavoritesList } from '@/features/consumer/favorites-list';

export const Route = createFileRoute('/(consumer)/_authenticated/favorites')({
  component: FavoritesPage,
});

function FavoritesPage() {
  return (
    <div className="space-y-6">
      <HeaderDashboard>
        <HeaderDashboard.Title>Favorites</HeaderDashboard.Title>
      </HeaderDashboard>

      <FavoritesList />
    </div>
  );
}
